const RX_PROTOCOL = /^(http|https):\/\//;
const RX_PATH = /\/.*/;

export default function refineUrl(url: string) {
    return url.replace(RX_PROTOCOL, '').replace(RX_PATH, '');
}
